<template>
  <div class="my-item">
    <div class="material">
      <template v-if="videoList && videoList.items.length">
        <Row :gutter="30" v-if="false">
          <Col span="8" v-for="(item, index) in videoList.items" :key="'video-me-' + index">
            <div class="material-list">
              <video-player
                class="video-player vjs-custom-skin"
                :ref="'videoPlayer-' + index"
                :playsinline="true"
                :options="playerOptions[index]"
                @play="onPlayerPlay($event, 'videoPlayer-' + index)"
                @pause="onPlayerPause($event)"
              ></video-player>
              <Poptip
                confirm
                title="确认删除此素材吗?"
                @on-ok="delVideo(item)"
                placement="bottom"
                class="close-video"
              >
                <Icon type="ios-trash-outline" size="20" color="#fff" style="cursor:pointer"></Icon>
              </Poptip>
            </div>
          </Col>
        </Row>

        <Row :gutter="30">
          <Col
            :sm="8"
            :md="6"
            class="w-20-1"
          >
            <div class="addVideo" @click="$emit('addVideo');">
              <div></div>
              <i class="icon iconfont icon-jia3"></i>
              <span>上传视频</span>
            </div>
          </Col>
          <Col
            :sm="8"
            :md="6"
            v-for="(item, index) in videoList.items"
            :key="'video-me-' + index"
            class="w-20-1"
          >
            <div class="video-list">
              <div class="material-list">
                <video-player
                  class="video-player vjs-custom-skin"
                  :ref="'videoPlayer-' + index"
                  :playsinline="true"
                  :options="playerOptions[index]"
                  @play="onPlayerPlay($event, 'videoPlayer-' + index)"
                  @pause="onPlayerPause($event)"
                ></video-player>
              </div>

              <div class="video-list-title" :title="item.name">{{ item.name }}</div>
              <div class="video-list-time" v-if="false">
                <template v-if="!item.isCharge">剩余：{{item.endTime | time_sort}}</template>
              </div>
              <div class="pro-tool">
                <Poptip
                  confirm
                  title="确认删除此视频吗 ?"
                  @on-ok="delVideo(item)"
                  class="pro-tool-item z-del"
                >删除</Poptip>
                <div class="pro-tool-line"></div>
                <div class="pro-tool-item z-primary" @click="showEdit(item)">编辑</div>
              </div>
            </div>
          </Col>
        </Row>

        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>

    <addVideo :show="add" @close="hideAdd()" @finish="init()" />

    <editVideo :show="edit" @close="hideEdit()" :info="editInfo" @finish="init()" />
  </div>
</template>

<script>
require("video.js/dist/video-js.css");
require("vue-video-player/src/custom-theme.css");
import { mapActions, mapGetters } from "vuex";
import { videoPlayer } from "vue-video-player";
import addVideo from "../components/add-video.vue";
import editVideo from "../components/edit-video.vue";
export default {
  name: 'video-material',
  data() {
    return {
      add: false,
      edit: false,
      editInfo: null,
      playerOptions: [],
      videoList: "",
      pageSize: 9,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  components: {
    videoPlayer,
    addVideo,
    editVideo
  },
  created() {
    this.init();
  },
  methods: {
    async delVideo(item) {
      let result = await this.delvideoMaterial(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    ...mapActions({
      getvideoMaterial: "materialModule/getvideoMaterial",
      delvideoMaterial: "materialModule/delvideoMaterial"
    }),
    async init() {
      this.videoList = await this.getvideoMaterial(this.option);
      let optArr = [];
      for (let i of this.videoList.items) {
        let arrStr = {
          autoplay: false,
          muted: false,
          loop: false,
          preload: "auto",
          language: "zh-CN",
          aspectRatio: "16:9",
          fluid: true,
          sources: [
            {
              type: "video/mp4",
              src: JSON.parse(i.videoInfo).Link
            }
          ],
          poster: JSON.parse(i.videoInfo).Img,
          width: document.documentElement.clientWidth,
          notSupportedMessage: "此视频暂无法播放，请稍后再试"
        };
        optArr.push(arrStr);
      }
      this.playerOptions = optArr;
      if (this.videoList) {
        this.pageSize = this.videoList.pageSize;
        this.pageIndex = this.videoList.pageIndex;
        this.totalCount = this.videoList.totalCount;
        this.$emit("showNum", this.totalCount);
      }
      this.$emit("finish");
    },
    sendAdd() {
      this.add = true;
    },
    hideAdd() {
      this.add = false;
    },
    showEdit(item) {
      this.edit = true;
      this.editInfo = item;
    },
    hideEdit() {
      this.edit = false;
      this.editInfo = null;
    },
    onPlayerPlay(player, name) {
      let key = Object.keys(this.$refs);
      key.forEach(c => {
        if (c !== name) {
          this.$refs[c][0].player.pause();
        }
      });
    },
    onPlayerPause(player) {},
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    }
  }
};
</script>

<style lang="scss">
.video-js .vjs-big-play-button {
  height: 2em;
  width: 2em;
  border-radius: 50%;
  line-height: 2em;
  top: 50% !important;
  left: 55% !important;
}
.vjs-poster {
  background-size: 100% 100%;
}
.ivu-modal-close {
  z-index: 1000;
}
</style>
<style lang="scss" scoped>
.material {
  background-color: #fff;
  padding: 18px;
  min-height: 500px;
  &-list {
    width: 100%;
    padding-bottom: 66.666667%;
    display: inline-block;
    position: relative;
    overflow: hidden;
    .close-video {
      position: absolute;
      right: 5px;
      top: 5px;
      z-index: 1000;
      visibility: hidden;
    }
    &:hover {
      .close-video {
        visibility: visible;
      }
    }
    .video-player {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      max-width: 100%;
      max-height: 100%;
      margin: auto;
    }
  }
}

.video {
  &-top {
    width: 100%;
    min-height: 100px;
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 20px 24px 0 36px;
    &-l {
      height: 100%;
      display: flex;
      flex-direction: column;
      .s1 {
        flex: 1;
        font-size: 14px;
        color: #8c8c8c;
      }
      .h1 {
        flex: 1;
        font-size: 18px;
        color: #333;
        font-weight: bold;
      }
      .s2 {
        flex: 1;
        font-size: 14px;
        color: #333;
      }
    }
    &-r {
      &-box {
        width: 150px;
        height: 80px;
        border: 1px dashed #1890ff;
        background-color: #e7f4ff;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        .I1 {
          font-size: 16px;
          font-weight: bold;
          color: #1890ff;
        }
        .s3 {
          font-size: 14px;
          color: #1890ff;
          margin-left: 9px;
        }
      }
    }
  }
  &-content {
    min-width: 1000px;
    padding: 30px;
    padding-bottom: 50px;
  }
  &-list {
    width: 100%;
    display: inline-block;
    background-color: #fff;
    margin-bottom: 30px;
    &-img {
      width: 100%;
      padding-bottom: 66.666667%;
      position: relative;

      img {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
      }
    }
    &-title {
      font-size: 14px;
      color: #1a1a1a;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      line-height: 66px;
      background: #fff;
      height: 66px;
      padding: 0 10px 0 12px;
    }
    &-time {
      width: 300px;
      min-height: 27px;
      padding-left: 10px;
      font-size: 14px;
      color: #fe791e;
    }
  }
}
.addVideo {
  background-color: #fafafa;
  width: 100%;
  padding-bottom: 66.666667%;
  position: relative;
  cursor: pointer;
  border: solid 1px #f2f2f2;
  div {
    width: 100%;
    height: 118px;
  }
  .icon{
    font-size: 60px;
    width: 100%;
    text-align: center;
    display: block;
    color:#999;
    position: absolute;
    bottom: 45%;
  }
  span{
    display: block;
    width: 100%;
    font-size: 18px;
    color:#999;
    text-align: center;
    position: absolute;
    bottom: 30%;
    text-align: center;
  }
}
.pro {
  &-tool {
    display: flex;
    height: 48px;
    align-items: center;
    justify-content: space-around;
    background-color: #f7f9fa;

    &-item {
      flex: 1;
      line-height: 48px;
      font-size: 14px;
      color: #808080;
      cursor: pointer;
      text-align: center;
      &:hover {
        color: #1890ff;
      }

      &.z-del {
        color: #f00;
      }
      &.z-primary {
        color: #1890ff;
      }
    }

    &-line {
      background-color: #e8e8e8;
      font-size: 20px;
      width: 1px;
      height: 22px;
    }
  }
}
</style>